import {svgIconWrapper} from '../svg-icon-wrapper';

import ChevronLightRegularLeftSvg from './chevron-light-regular-left-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ChevronLightRegularLeftSvg {...props} />;
}
SvgComponent.iconName = 'chevronLightRegularLeft';

export const ChevronLightRegularLeft = svgIconWrapper(SvgComponent);
